// Referral Points & Committee Leadership System (Dr. Sabitha Mam's Initiative)
// Reference IDs award points when new members register on Google Form (₹100 fee)
// Points determine appointments to President, Vice President, Secretary, Joint Secretary

const STORAGE_KEY = 'arivunest_referral_points_v22';

// Baseline real referral points from official Google Form submissions
// 1. Dr. D. Lourdhu Mary, Ph.D (ANRD/AB/2026/002) = 40 pts (Referred by Samuel Santhosh, Malliga N, S. Ambigabathi, A. Sathiyavathi)
// 2. Dr. B. Balamayurathan, Ph.D (ANRD/AB/2026/022) = 30 pts (Referred by Subitsha S, M. Siva Ram Sanker, Vaishali M)
// 3. Dr. T. Ezhilarasi, Ph.D (ANRD/AM/2026/008) = 20 pts (Referred by K. Muthukumar & M. Praveenkumar)
// All others = 0 pts
export const INITIAL_REFERRAL_POINTS = {
  'ANRD/AB/2026/001': 0,  // Mrs. M. Geetha
  'ANRD/AB/2026/002': 130, // Dr. D. Lourdhu Mary, Ph.D (13 Verified Referrals - Sole Lead Rank #1) // Dr. D. Lourdhu Mary, Ph.D (12 Verified Referrals - Sole Lead Rank #1) // Dr. D. Lourdhu Mary, Ph.D (11 Verified Referrals - Sole Lead Rank #1)
  'ANRD/AM/2026/003': 0,  // Mr. Brahma Naidu Chavali
  'ANRD/AB/2026/004': 0,  // Dr. R. Kumara Balaji, Ph.D
  'ANRD/AB/2026/005': 0,  // Dr. M. Leena Chandrika, Ph.D
  'ANRD/AB/2026/006': 0,  // Dr. A. Balasubramanian, Ph.D
  'ANRD/AM/2026/007': 0,  // Ms. B. Malini
  'ANRD/AM/2026/008': 30, // Dr. T. Ezhilarasi, Ph.D (3 Verified Referrals - Rank #3)
  'ANRD/AB/2026/009': 0,  // Prof. M. Nallakurumban
  'ANRD/AB/2026/010': 0,  // Prof. E. Annal Sheeba Rani
  'ANRD/AM/2026/011': 0,  // Dr. Mydhili S.K., Ph.D
  'ANRD/AM/2026/012': 0,  // Prof. K. Muthukumar
  'ANRD/AB/2026/013': 0,  // Prof. M. Praveenkumar
  'ANRD/AM/2026/014': 0,  // Prof. T. Udhayakumar
  'ANRD/AM/2026/015': 0,  // Prof. S. Jayaprakash
  'ANRD/AB/2026/016': 0,  // Mr. Debabrata Roy
  'ANRD/AB/2026/017': 0,  // Dr. N. Maryanna Harris, Ph.D
  'ANRD/AB/2026/018': 90, // Dr. K. Vinoth, Ph.D (9 Verified Referrals - Rank #2 Lead)
  'ANRD/AB/2026/019': 0,  // Dr. M. S. Parkavi, Ph.D
  'ANRD/AB/2026/020': 20, // Prof. A. Dinesh Kumar (2 Verified Referrals - 20 Points) // Prof. A. Dinesh Kumar (1 Verified Referral - 10 Points)
  'ANRD/AB/2026/021': 0,  // J. Samuel Santhosh
  'ANRD/AB/2026/022': 70, // Dr. B. Balamayurathan, Ph.D (7 Verified Referrals - Rank #2 Lead)
  'ANRD/AM/2026/023': 0,  // Mrs. S. Subitsha
  'ANRD/AM/2026/024': 0,  // Mr. M. Siva Ram Sanker
  'ANRD/AM/2026/025': 0,  // Ms. Malliga N
  'ANRD/AM/2026/026': 0,  // Mrs. S. Ambigabathi
  'ANRD/AM/2026/027': 0,  // Ms. M. Vaishali
  'ANRD/AM/2026/028': 0,  // Ms. S. Vaishnavi Shri
  'ANRD/AM/2026/029': 0,  // Dr. A. Sathiyavathi, Ph.D
  'ANRD/AM/2026/030': 0,  // Mr. A. Karthick
  'ANRD/AM/2026/031': 0,  // Dr. B. Mythili, Ph.D
  'ANRD/AM/2026/032': 0,  // Ms. R. Janani
  'ANRD/AM/2026/033': 0,  // Ms. K. R. Sowmiya
  'ANRD/AM/2026/034': 0,  // Dr. K. Usha Savithri, Ph.D
  'ANRD/AM/2026/035': 0,  // Dr. G. Pavithra, Ph.D
  'ANRD/AB/2026/036': 0,  // Dr. J. Veneeswari, Ph.D
  'ANRD/AM/2026/037': 0,  // Ms. S. Karthika, M.Phil
  'ANRD/AM/2026/038': 0,  // Ms. R. Sonaalee
  'ANRD/AM/2026/039': 0,  // Dr. A. Malika Begum, Ph.D
  'ANRD/AM/2026/040': 0,  // Dr. A. Anjana, Ph.D
  'ANRD/AM/2026/041': 0,  // Ms. Jenifer R
  'ANRD/AB/2026/042': 0,  // Mr. K. Maheshwaran
  'ANRD/AB/2026/043': 0,  // Dr. K. Babu, Ph.D
  'ANRD/AB/2026/044': 0,  // Dr. A. Nagamani Prabu, Ph.D
  'ANRD/AB/2026/045': 0,  // Dr. K. Muthulakshmi, Ph.D
  'ANRD/AM/2026/046': 0,  // Mr. S. Nagarajan
  'ANRD/AM/2026/047': 0,  // Ms. L. Kanimozhi
  'ANRD/AM/2026/048': 0,  // Ms. G. Hemaladevi
  'ANRD/AM/2026/049': 0,  // Dr. N. A. S. Vinoth, Ph.D
  'ANRD/AB/2026/050': 0,  // Dr. Kalpana C, Ph.D
  'ANRD/AB/2026/051': 0,  // Dr. S. Delsi Robinsha, Ph.D
  'ANRD/AM/2026/052': 0,  // Ms. Tanusya
  'ANRD/AM/2026/053': 0,  // Prof. B. Indrajith
  'ANRD/AB/2026/054': 0,  // Prof. Julia P
  'ANRD/AM/2026/055': 0,  // Dr. Aparna Ramesh, Ph.D
  'ANRD/AB/2026/056': 0,  // Dr. A. Bala Vanitha, Ph.D
  'ANRD/AM/2026/057': 0,  // Dr. M. Hamsalatha, Ph.D
  'ANRD/AB/2026/058': 0,  // Dr. R. Bathridevanath, Ph.D
  'ANRD/AM/2026/059': 0,  // A. Lincy Annet
  'ANRD/AB/2026/060': 0,  // Dr. L. Sugirtha, Ph.D
  'ANRD/AB/2026/061': 0,  // Dr. M. Vasanthamullai, Ph.D
  'ANRD/AM/2026/062': 0   // Prof. J. Farida, M.Phil
};

export const getAllPoints = () => {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved) {
      const parsed = JSON.parse(saved);
      return { ...INITIAL_REFERRAL_POINTS, ...parsed };
    }
  } catch (e) {
    console.error('Failed to parse referral points', e);
  }
  return { ...INITIAL_REFERRAL_POINTS };
};

export const getPointsForMember = (refId) => {
  const all = getAllPoints();
  return all[refId] !== undefined ? all[refId] : 0;
};

export const savePoints = (refId, points) => {
  const all = getAllPoints();
  all[refId] = Number(points) || 0;
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(all));
    window.dispatchEvent(new Event('arivunest-points-updated'));
  } catch (e) {
    console.error('Failed to save referral points', e);
  }
  return all;
};

export const addPoints = (refId, increment = 10) => {
  const current = getPointsForMember(refId);
  return savePoints(refId, current + increment);
};

export const resetAllPointsToForm = () => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(INITIAL_REFERRAL_POINTS));
    window.dispatchEvent(new Event('arivunest-points-updated'));
  } catch (e) {
    console.error('Failed to reset referral points', e);
  }
  return { ...INITIAL_REFERRAL_POINTS };
};

export const getRoleForRank = (rank) => {
  switch (rank) {
    case 1:
      return { title: 'President Contender', badge: '👑 1st Rank (President)', color: '#047857', bg: '#ecfdf5' };
    case 2:
      return { title: 'Vice President Contender', badge: '🥈 2nd Rank (Vice President)', color: '#0369a1', bg: '#f0f9ff' };
    case 3:
      return { title: 'Secretary Contender', badge: '🥉 3rd Rank (Secretary)', color: '#b45309', bg: '#fffbeb' };
    case 4:
      return { title: 'Joint Secretary Contender', badge: '🎖️ 4th Rank (Joint Secretary)', color: '#6d28d9', bg: '#f5f3ff' };
    default:
      return { title: 'Executive Committee Member', badge: '🎗️ Committee Contender', color: '#475569', bg: '#f8fafc' };
  }
};

export const getRankedMembers = (membersList) => {
  const pointsMap = getAllPoints();
  const withPoints = membersList.map((m) => {
    const pts = pointsMap[m.refId] !== undefined ? pointsMap[m.refId] : 0;
    return { ...m, referralPoints: pts };
  });

  // Sort descending by points; tiebreaker preserves earlier refId
  withPoints.sort((a, b) => b.referralPoints - a.referralPoints);

  return withPoints.map((m, index) => {
    const rank = index + 1;
    return {
      ...m,
      rank,
      roleDesignation: getRoleForRank(rank)
    };
  });
};

export const getWhatsAppShareUrl = (member) => {
  const message = `🏛️ *ARIVU NEST – RESEARCH AND DEVELOPMENT*
(Unit of Jjegan Graphers • MSME Govt. of India: UDYAM-TN-32-0048110)
In Association with Kani Rathnam Equality Foundation

Dear Colleague / Student,

I invite you to join the official *Arivu Nest R&D Institutional Forum*.

🌟 *Key Benefits:*
• Lifetime Membership Certificate & Official ID
• Editorial Board Roles in upcoming ISSN Journals & ISBN Books
• Free Access to National Seminars, FDPs & Publication Mentorship
• Open to all Arts, Science, Engineering & Management faculties

💰 *Promotional Lifetime Fee:* ₹100 only (Valid until Nov 30)

✍️ *Registration Link:*
https://forms.gle/UfkUncKELYenUJE46

⚠️ *IMPORTANT:* Please enter my Reference ID in the Reference Column:
👉 *${member.refId}* (${member.name})

🔍 *Verify My Credentials:*
https://arivunest.com/verify?id=${encodeURIComponent(member.refId)}`;

  return `https://api.whatsapp.com/send?text=${encodeURIComponent(message)}`;
};
